import React, { FC } from "react";

const CustomInput: FC<{
  label: string;
  value: any;
  maxLength?: number;
  required?: boolean;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: any) => void;
}> = ({
  label,
  value,
  required,
  disabled,
  type,
  onChange,
  placeholder,
  maxLength,
}) => {
  return (
    <div className="m-customInput__container">
      <label className="a-customInput__label" htmlFor="">
        {label}
        {required ? (
          <span className="a-customInput__labelRequired">*</span>
        ) : (
          ""
        )}
      </label>
      <input
        className="a-customInput__input"
        type={type || "text"}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        maxLength={maxLength}
      />
    </div>
  );
};

export default CustomInput;
